import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  contentStyle: {
    flex: 1,
    marginTop: 142,
  },
  subHeaderTitle: {
    paddingTop: 15,
    paddingBottom: 22,
  },
  titleStyle: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25.1,
  },
  amountStyle: {
    fontFamily: Fonts.type.base,
    fontSize: 25.1,
    fontWeight: 'bold',
    marginTop: 8,
  },
  sectionHeaderStyle: {
    marginBottom: 16.1,
  },
});
